export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_FIRSTNAME (state, firstname) {
    state.firstname = firstname
  },
  SET_LASTNAME (state, lastname) {
    state.lastname = lastname
  },
  SET_UPDATED (state, updated) {
    state.updated = updated
  },
  SET_USERNAME (state, username) {
    state.username = username
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_ROLEID (state, role) {
    state.roleID = role
  },
  SET_SEARCHRESULTS (state, results) {
    state.searchResults = results
  },
  SET_HASNEXTPAGE (state, hasNextPage) {
    state.hasNextPage = hasNextPage
  },
  SET_CURRENT_DEVICE (state, device) {
    state.currentDevice = {...device}
  },
  SET_MESSAGE_LIST (state, messages) {
    state.messageList = messages
  },
  SET_LANGUAGE_LIST (state, languages) {
    state.languageList = languages
  },
  SET_MESSAGE_TYPES (state, types) {
    state.messageTypes = types
  },
  SET_TENANT_GROUPS (state, groups) {
    state.tenantGroupList = groups
  },
  SET_USER_ROLES (state, roles) {
    state.userRoles = roles
  },
  SET_USER_LIST (state, users) {
    state.userList = users
  },
  SET_ROLE_SELECTION (state, roleSelected) {
    state.roleSelected = roleSelected
  },
  SET_API_LIST (state, apis) {
    state.apiList = apis
  },
  SET_ROLE_API_LIST (state, apisRole) {
    state.apiRoleList = apisRole
  },
  SET_TENANTS_LIST (state, payload) {
    state.tenantsList = payload
  },
  SET_FIRST_TENANT (state, firstTenant) {
    state.firstTenant = firstTenant
  },
  SET_DEVICES_LIST (state, payload) {
    state.devicesList = payload
  },
  SET_LOW_LEAK_ALERTS (state, payload) {
    state.lowLeakAlerts = payload
  },
  SET_REPAIRS (state, payload) {
    state.repairs = payload
  },
  SET_DAMAGE_CAUSING_REPAIRS (state, payload) {
    state.damageCausingRepairs = payload
  },
  SET_LEAK_CATEGORIES (state, payload) {
    state.leakCategories = payload
  },
  SET_WORK_ORDER_CLAIM_SAVINGS (state, payload) {
    state.workOrderClaimSavings = payload
  },
  SET_COST_OF_PROGRAMME (state, payload) {
    state.costOfProgramme = payload
  },
  SET_LAST_INVOICE_MONTH (state, payload) {
    state.lastInvoiceMonth = payload
  },
  SET_CUSTOMER_FEEDBACK (state, payload) {
    state.customerFeedback = payload
  },
  SET_MARKETING_METRICS (state, payload) {
    state.marketingMetrics = payload
  },
  SET_ORDERS_AND_REGISTRATIONS (state, payload) {
    state.ordersAndRegistrations = payload
  },
  SET_MONTHLY_REGISTRATIONS (state, payload) {
    state.monthlyRegistrations = payload
  },
  SET_LEAKLIST (state, payload) {
    state.leakList = payload
  },
  addToken: function (state, token) {
    state.token = token
    if (token) {
      state.loggedInStatus = true
    } else {
      state.loggedInStatus = false
    }
  },
  // addCookie: function (state, cookie) {
  //  state.cookie = cookie
  // },
  addRoleID: function (state, roleID) {
    state.roleID = roleID
  },
  addSecret: function (state, secretKey) {
    state.secretKey = secretKey
  },
  removeSecret: function (state) {
    state.secretKey = null
  },
  removeEverything: function (state) {
    Object.keys(state).forEach(key => {
      state[key] = null
    })
  },
  addUsername: function (state, username) {
    state.username = username
  },
  addPassword: function (state, password) {
    state.password = password
  },
  removeUsername: function (state) {
    state.username = null
  },
  removePassword: function (state) {
    state.password = null
  },
  dynamicsLogin: function (state, dynamics) {
    state.dynamics = dynamics
  },
  dynamicsLoginRemoved: function (state) {
    state.dynamics = null
  },
  addOTP: function (state, otp) {
    state.otp = otp
  },
  addOTPauth: function (state, otpauth) {
    state.otpauth = otpauth
  },
  removeOTPauth: function (state) {
    state.otpauth = null
  },
  removeToken: function (state) {
    state.token = ''
    state.loggedInStatus = false
  },
  SET_TOKEN (state, token) {
    state.token = token
    if (token) {
      state.isUserLoggedIn = true
    } else {
      state.isUserLoggedIn = false
    }
  },
  // setCookie (state, cookie) {
  //  state.cookie = cookie
  // },
  SET_NOSIGNAL (state, noSignal) {
    state.noSignal = noSignal
  },
  SET_DONUTSDATA (state, donutsData) {
    state.donutsData = donutsData
  },
  SET_K1 (state, k1) {
    state.k1 = k1
  },
  SET_K0 (state, k0) {
    state.k0 = k0
  },
  SET_K2 (state, k2) {
    state.k2 = k2
  },
  SET_K3 (state, k3) {
    state.k3 = k3
  },
  SET_K4 (state, k4) {
    state.k4 = k4
  },
  SET_K5 (state, k5) {
    state.k5 = k5
  },
  SET_K6 (state, k6) {
    state.k6 = k6
  },
  SET_K7 (state, k7) {
    state.k7 = k7
  },
  SET_K8 (state, k8) {
    state.k8 = k8
  },
  SET_K9 (state, k9) {
    state.k9 = k9
  },
  SET_K10 (state, k10) {
    state.k10 = k10
  },
  SET_K11 (state, k11) {
    state.k11 = k11
  },
  SET_K12 (state, k12) {
    state.k12 = k12
  },
  SET_K13 (state, k13) {
    state.k13 = k13
  },
  SET_Installed (state, Installed) {
    state.Installed = Installed
  },
  SET_LeakActive (state, LeakActive) {
    state.LeakActive = LeakActive
  },
  SET_LeakInactive (state, LeakInactive) {
    state.LeakInactive = LeakInactive
  },
  SET_Learning (state, Learning) {
    state.Learning = Learning
  },
  SET_Other (state, Other) {
    state.Other = Other
  },
  setDonuts: (state, payload) => {
    state.donutsValues.data = payload
  },
  setDonutsData: (state, payload) => {
    state.donutsData.values = payload
  },
  setInstallsDonut: (state, payload) => {
    state.installsDonut.values = payload
  },
  setAllDonutsData: (state, payload) => {
    state.alldonutsData.values = payload
  },
  setSelectedTenantID: (state, selectedTenantID) => {
    state.selectedTenantID = selectedTenantID
  },
  setTenantsGroupList: (state, tenantsGroupList) => {
    state.tenantsGroupList = tenantsGroupList
  },
  setEventList: (state, payload) => {
    state.eventList.data = payload
  },
  setIncompleteInstallsList: (state, payload) => {
    state.incompleteInstallsList.data = payload
  },
  setDropdownDonutsValues: (state, payload) => {
    state.dropdownDonutsValues.data = payload
  },
  selecta: (state, payload) => {
    console.log('!!selecta!!')
    state.selecta = payload
  },

  // Auth0 mutations
  SET_AUTH0_CLIENT (state, client) {
    state.auth0Client = client
  },
  SET_AUTH0_LOADING (state, isLoading) {
    state.auth0IsLoading = isLoading
  },
  SET_AUTH0_AUTHENTICATED (state, isAuthenticated) {
    state.auth0IsAuthenticated = isAuthenticated
  },
  SET_AUTH0_USER (state, user) {
    state.auth0User = user
  },
  SET_AUTH0_ERROR (state, error) {
    state.auth0Error = error
  }

}
